const ICON_PATHS = [
  <>
    <circle cx="20" cy="20" r="15" />
    <path d="M20 8 L20 20 L28 26" />
  </>,
  <>
    <path d="M20 6 C10 6 8 18 8 24 C8 31 13 34 20 34 C27 34 32 31 32 24 C32 18 30 6 20 6 Z" />
    <path d="M20 6 L20 34" />
  </>,
  <>
    <circle cx="20" cy="14" r="6" />
    <path d="M20 20 L20 34 M12 27 L28 27" />
  </>,
  <>
    <path d="M20 6 C26 12 26 20 20 20 C14 20 14 28 20 34" />
    <circle cx="20" cy="6" r="2.4" fill="currentColor" stroke="none" />
  </>,
  <>
    <path d="M20 6 L20 22 L28 30 M20 22 L13 30" />
    <path d="M9 34 Q20 38 31 34" />
  </>,
];

export function DefaultIcon({ index }) {
  return (
    <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.6">
      {ICON_PATHS[index % ICON_PATHS.length]}
    </svg>
  );
}
